import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ChooseCycleType } from "./ChooseCycleType";
import type { CycleType } from "./Config";
import { ReviewCycleWizard } from "./ReviewCycleWizard";

import { useAvailableCycleTypes } from "./hooks/useAvailableCycleTypes";
import { useNavChromeBottom } from "./hooks/useNavChromeBottom";

const REVIEW_CYCLES_PATH = "/company/reviews/cycles";

export const ReviewCycleCreateRouter = () => {
	const navigate = useNavigate();
	const [selectedType, setSelectedType] = useState<CycleType | null>("manual");
	const [started, setStarted] = useState(false);
	const { topOffset, measureRef } = useNavChromeBottom();
	const { options, isLoading, isGroupAdminOnly } = useAvailableCycleTypes();

	const selectableOptions = useMemo(() => options.filter((o) => !o.disabled), [options]);

	const shouldSkipSelection = !isLoading && (isGroupAdminOnly || selectableOptions.length === 1);
	const resolvedType = shouldSkipSelection ? (selectableOptions[0]?.type ?? null) : selectedType;

	return (
		<div
			ref={measureRef}
			className="fixed inset-x-0 bottom-0 z-10 overflow-hidden"
			style={{
				top: topOffset ?? 64,
				visibility: topOffset === null ? "hidden" : "visible",
			}}
		>
			{!started && !shouldSkipSelection ? (
				<ChooseCycleType
					selectedType={selectedType}
					onSelect={setSelectedType}
					onCancel={() => navigate(REVIEW_CYCLES_PATH)}
					onGetStarted={() => setStarted(true)}
				/>
			) : (
				<ReviewCycleWizard
					cycleType={resolvedType ?? "manual"}
					onExit={() => navigate(REVIEW_CYCLES_PATH)}
					onCreated={(cycleId) => navigate(`/review-cycle/${cycleId}`)}
				/>
			)}
		</div>
	);
};
